import React from 'react'
import Layout from '../layout/layout'
// import { Link } from "gatsby"
import SEO from "../layout/seo"
import './styles/schedule.scss'
import Schedule from '../components/sessionize/Schedule'
import { Link } from 'gatsby-plugin-modal-routing-3'
import imgHeroLogo from "../images/ignite-summit-icon-turquoise.svg"

const schedule = () => {
     
    return (
        <Layout attr="schedule">
            <SEO title="Ignite Summit: Schedule" />
            <div className="innerHeader">
                <div className="container">
                    <img src={imgHeroLogo} width={`57px`} height={`40px`} />
                    <h1>Ignite summit <span className="turquoise">schedule</span></h1>
                </div>
            </div>
            <div className="container header-content" >
                <p>There’s no single, right place to get started with modernizing your data architecture. But Ignite Summit is a great place to explore your options and pick up tips from developers and architects who have already been there.</p>

                <p>Get ready to immerse yourself in a full day of engineering use cases, architectural overviews, and inspirational journeys from Ignite community members. Or you can make it a two-day event and join one of our <Link
                    to="/training"
                  >pre-summit training sessions</Link>.</p>
                  <div className="buttons">
                    <Link
                        to="https://events.ringcentral.com/events/ignite-summit-2025"
                        className="more button"
                    >
                        register
                    </Link>
                </div>
            </div>

            <div className="schedule-items">
                <div className="schedule-wrapper">
                    <div className="container">
                        
                        <Schedule />
                        
                    </div>
                </div>
            </div>
            
        </Layout>
    )
}

export default schedule